import { BaggageType } from '@websky/graphql';
import * as React from 'react';
import { CdnIcon, CdnIconNames } from '@shared/ui';
import CdnImage from '../../CdnImage/CdnImage';

interface Props {
	baggageType?: BaggageType;
	rfisc?: string;
	className?: string;
}

const ICON_BY_BAGGAGE_TYPE: Partial<Record<BaggageType, CdnIconNames>> = {
	[BaggageType.CarryOn]: 'Baggage/Cabin',
	[BaggageType.CheckedBaggage]: 'Baggage/Checked-in',
	[BaggageType.BaggageExcess]: 'Baggage/Overweight',
	[BaggageType.HandLuggageExcess]: 'Baggage/Cabin Upsize',

	[BaggageType.PetInCabin]: 'Baggage/Pet in cabin',
	[BaggageType.PetInHold]: 'Baggage/Pet in cargo',
	[BaggageType.PetInHandCarrier]: 'Baggage/Pet in saloon',

	[BaggageType.SportingEquipment]: 'Baggage/Sport Equipment',
	[BaggageType.SurfingEquipment]: 'Baggage/Serfing',
	[BaggageType.Ski]: 'Baggage/Ski',
	[BaggageType.FishingEquipment]: 'Baggage/Fishing',
	[BaggageType.Bike]: 'Baggage/Byke',

	[BaggageType.MusicalInstrument]: 'Baggage/Musical inst'
};

const BaggageIcon: React.FC<Props> = React.memo(({ baggageType, rfisc, className }) => {
	if (!rfisc && !baggageType) {
		return null;
	}

	const iconName = baggageType ? ICON_BY_BAGGAGE_TYPE[baggageType] : undefined;
	const fallbackIcon = iconName ? <CdnIcon icon={iconName} className={className} /> : undefined;

	if (rfisc) {
		return (
			<CdnImage
				className={className}
				// временно заменен путь для baggage icons, убрать oldIcons когда согласуют новые иконки с а/к
				path={`icons/baggage/oldIcons/${rfisc}.svg`}
				contentRepo
				emptyImage={
					baggageType ? (
						<CdnImage
							className={className}
							path={`icons/baggage/${baggageType}.svg`}
							contentRepo
							emptyImage={fallbackIcon}
						/>
					) : undefined
				}
			/>
		);
	}

	return (
		<CdnImage
			className={className}
			path={`icons/baggage/${baggageType}.svg`}
			contentRepo
			emptyImage={fallbackIcon}
		/>
	);
});

BaggageIcon.displayName = 'BaggageIcon';

export default BaggageIcon;
